import React from 'react';
import Watchword from '../assets/watchword.jpg'

const LargeCard = ( ) => {
  return (
    <div className="h-full w-screen flex flex-col md:flex md:flex-row items-center justify-center space-x-0 md:space-x-9">
     
        <div className="w-screen h-[400px] md:w-[520px] mt-[10px] md:mt-0 md:h-[400px] flex flex-col justify-center items-center rounded-lg overflow-hidden shadow-lg relative">
          <img src={Watchword} alt="BackgroundImage" className="absolute inset-0 object-cover"/>
          <div className="bg-blue-950 absolute inset-0 opacity-30"></div>
          <div className="relative">
            <h1 className='text-white text-center font-bold text-5xl mx-[16px] mb-4'>Watchword</h1>
            <p className="font text-white text-2xl mx-[16px] mb-4">"Remove from me reproach and contempt; for i have kept thy testimonies"</p>
            <h1 className='text-white text-center font-medium text-lg mx-[16px] mb-4'>(Psalm:119 vs 22)</h1>
          </div>
        </div>
        <div className="w-screen h-[400px] md:w-[520px] mt-[10px] md:mt-0 md:h-[400px] flex flex-col justify-center items-center rounded-lg overflow-hidden shadow-lg relative">
          <img src={Watchword} alt="BackgroundImage" className="absolute inset-0 object-cover"/>
          <div className="bg-blue-950 absolute inset-0 opacity-30"></div>
          <div className="relative">
            <h1 className='text-white text-center font-bold text-5xl mx-[16px] mb-4'>Akomona</h1>
            <p className="font text-white text-2xl mx-[16px] mb-4">"mu egan ati abuku kuro lara mi; nitori emi ti pa eri re mo"</p>
            <h1 className='text-white text-center font-medium text-lg mx-[16px] mb-4'>(orin dafidi 119 vs 22)</h1>
          </div>
        </div>
                
      </div>
      
  );
};

export default LargeCard;